import React, { useEffect } from 'react';
import { StyledContainer } from '../Content.styles';
import { Headline, Paragraph } from '@cambridgeassessment/cambridge-ui';
import Selector from './components/Selector';
import { useFlag } from '@unleash/proxy-client-react';
import { Authorized, FEATURE_FLAGS } from 'lib-browser';
import { useHistory } from 'react-router-dom';
import { Roles } from '@cambridgeassessment/lib-ee-commons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const PostResultsPage: React.FC = () => {
  const history = useHistory();
  const {
    userData: { selectedRole },
  } = useSelector((state: RootState) => state);
  const isFeatureFlagEnabled = useFlag(FEATURE_FLAGS.postResults_ff);

  useEffect(() => {
    if (!isFeatureFlagEnabled) {
      history.replace('/');
    }
  }, [isFeatureFlagEnabled, history]);

  return (
    <Authorized selectedRole={selectedRole} roles={[Roles.SUBMIT_SUPER_ADMIN, Roles.SUBMIT_ADMINISTRATOR]}>
      <StyledContainer data-qa-id='page-priming-post-results'>
        <Headline data-qa-id='post-results-headline'>Post results apportionment</Headline>
        <Paragraph data-qa-id='post-results-paragraph'>Allocate assessors to post results services.</Paragraph>
      </StyledContainer>
      <Selector />
    </Authorized>
  );
};

export default PostResultsPage;
